module.exports = __webpack_public_path__ + "img/Profile-9.ceed36e2.png";